import
{
  Button,
  Progress,
  Cascader,
  Pagination,
  DatePicker,
  DateRangePicker,
  Table,
  Form,
  FormItem,
  Popup,
}
  from 'tdesign-vue-next';
import { createComponent } from './utils/index';
import TlbsBaseMap from './base-map';

export * from './image/index';
export * from './music-player/index';
export * from './container/index';
export * from './swiper/index';
export * from './select/index';
export * from './chart/index';
export * from './video/index';
export * from './base-map/index';
export * from './submap-container/index';
export { TlbsGroup } from './radio/index';
export * from './jue-map/index';
export * from './text/index';
export * from './slider/index';
export * from './link/index';
export * from './menu/index';
export * from './tabs/index';
export * from './iframe/index';
export * from './markdown/index';
export * from './model/index';
export * from './sug-select/index';

export * from './form-item/index';
export * from './dialog/index';
export * from './city-select/index';
export * from './input/index';
// markdown 相关
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import markdownPlugins from './utils/markdownPlugin/markdownPlugin';
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import hljs from 'highlight.js';

VMdPreview.use(githubTheme, {
  Hljs: hljs,
  extend: markdownPlugins,
});

export const TlbsButton = createComponent(Button, 'TlbsButton');
export const TlbsProgress = createComponent(Progress, 'TlbsProgress');
export const TlbsHeatMap = createComponent(TlbsBaseMap, 'TlbsHeatMap');
export const TlbsGridMap = createComponent(TlbsBaseMap, 'TlbsGridMap');
export const TlbsTrailMap = createComponent(TlbsBaseMap, 'TlbsTrailMap');
export const TlbsDotMap = createComponent(TlbsBaseMap, 'TlbsDotMap');
export const TlbsWemapBaseMap = createComponent(TlbsBaseMap, 'TlbsWemapBaseMap');
export const TlbsVMdPreview = VMdPreview;
export const TlbsCascader = createComponent(Cascader, 'TlbsCascader');
export const TlbsPagination = createComponent(Pagination, 'TlbsPagination');
export const TlbsDatePicker = createComponent(DatePicker, 'TlbsDatePicker');
export const TlbsDateRangePicker = createComponent(DateRangePicker, 'TlbsDateRangePicker');
export const TlbsTable = createComponent(Table, 'TlbsTable');
export const TlbsForm = createComponent(Form, 'TlbsForm');
export const TlbsFormItem = createComponent(FormItem, 'TlbsFormItem');
export const TlbsPopup = createComponent(Popup, 'TlbsPopup');
